export const INITIAL_UPDATE_REQUEST = "INITIAL_UPDATE_REQUEST";
export const FINAL_UPDATE_REQUEST = "FINAL_UPDATE_REQUEST";

export const FETCH_UPDATES_SUCCESS = "FETCH_UPDATE_POSTS_SUCCESS";
export const SAVE_UPDATE_SUCCESS = "SAVE_UPDATE_SUCCESS";

export const DELETE_UPDATE_SUCCESS = "DELETE_UPDATE_SUCCESS";

export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";

export const ERROR = "ERROR";
